export interface LayoutContextInterface {
  title: string;
}

export enum LayoutTypesEnum {
  CONFIGURE_PAGE,
}
